import { SetStateAction } from "react";
import { colors } from "../../../data/colors";
import { stdObject } from "../../../data/types/stdObject";
import i18n from "../../../locales/i18n";
import { verifyWebData } from "../../../services/verifyWebData";

const webSettingsInputs = [
  { code: "ACTWEB", label: "p.active", type: "checkbox" },
  { code: "TARWEB", label: "p.price", type: "select" },
  {
    code: "SYNCWEB",
    label: "p.sync",
    type: "select",
    options: [
      { label: "p.5min", value: 300000 },
      { label: "p.10min", value: 600000 },
      { label: "p.30min", value: 1800000 },
      { label: "p.1hour", value: 3600000 },
    ],
  },
  { code: "PAIWEB", label: "p.country", type: "select" },
  {
    code: "",
    label: "p.connection",
    type: "label",
    style: { backgroundColor: colors.settings },
  },
  { code: "URLFTP", label: "URL" },
  { code: "TOKENFTP", label: "Token" },
  {
    code: "OKFTP",
    label: "p.verify",
    type: "tableButton",
    color: colors.darkGrey,
  },
  {
    code: "",
    label: "p.email",
    type: "label",
    style: { backgroundColor: colors.settings },
  },
  { code: "CODMAIL", label: "p.email" },
  { code: "NOMMAIL", label: "p.name" },
  { code: "HOSTMAIL", label: "p.server" },
  {
    code: "SECMAIL",
    label: "p.security",
    type: "select",
    options: [
      { label: "", value: "" },
      { label: "SSL", value: "ssl" },
      { label: "TLS", value: "tls" },
    ],
  },
  { code: "AUTHMAIL", label: "p.authentication", type: "checkbox" },
  { code: "PORTMAIL", label: "p.port" },
  { code: "USERMAIL", label: "p.user" },
  { code: "PASSMAIL", label: "p.password", type: "passwordInput" },
  {
    code: "OKMAIL",
    label: "p.verify",
    type: "tableButton",
    color: colors.darkGrey,
  },
];

const webVerifyFields = {
  OKSQL: ["HOSTSQL", "USERSQL", "PASSSQL", "DATSQL", "PORTSQL"],
  OKFTP: ["URLFTP", "TOKENFTP"],
  OKMAIL: [
    "CODMAIL",
    "NOMMAIL",
    "HOSTMAIL",
    "SECMAIL",
    "AUTHMAIL",
    "PORTMAIL",
    "USERMAIL",
    "PASSMAIL",
  ],
};

export const webSettingsModal = ({
  t,
  pricesRates,
  saveWebSetting,
  windowValues,
  setMsg2,
  setWindowValues,
  startSendData,
  closeMsg,
}: stdObject) => {
  const getWebData = (code: string) =>
    Object.entries(windowValues.webSettings).reduce(
      (acc: stdObject, curr: [string, any]) => {
        if (
          webVerifyFields[code as "OKSQL" | "OKFTP" | "OKMAIL"].includes(
            curr[0],
          )
        ) {
          acc[curr[0]] = curr[1];
        }
        return acc;
      },
      {},
    );
  return "webSettings" in windowValues
    ? {
        title: t(`p.settings`),
        blocked: true,
        inputs: webSettingsInputs.map((e: stdObject) => {
          let options = [];
          switch (e.code) {
            case "TARWEB":
              options = [
                { label: "", value: "" },
                ...pricesRates.map((v: stdObject) => {
                  return { label: v.NOMTAR, value: v.CODTAR };
                }),
              ];
              break;
            case "PAIWEB":
              const language = i18n.language;
              const countriesList = (
                i18n.store.data[language].translation as Record<string, any>
              ).country;
              options = [
                { label: "", value: "" },
                ...Object.entries(countriesList).map((e) => {
                  return { label: e[1], value: e[0] };
                }),
              ];
              break;
            default:
              if (e.options) {
                options = e.options.map((v: stdObject) => {
                  return { ...v, label: t(v.label) };
                });
              }
              break;
          }
          return {
            label:
              e.type === "tableButton"
                ? windowValues.webSettings[e.code] === false
                  ? t("p.failed")
                  : windowValues.webSettings[e.code]
                    ? t("p.verified")
                    : t(e.label)
                : t(e.label),
            value: windowValues.webSettings[e.code],
            type: e.type,
            options,
            style: { width: 300, ...e.style },
            innerStyle: {
              color:
                e.type === "tableButton"
                  ? windowValues.webSettings[e.code]
                    ? colors.green
                    : windowValues.webSettings[e.code] === false
                      ? colors.red
                      : e.color
                  : null,
            },
            onChange: (v: { target: { value: SetStateAction<string> } }) => {
              let tempValues = windowValues.webSettings;
              tempValues[e.code] =
                e.type === "checkbox"
                  ? Number(v.target.value)
                    ? 0
                    : 1
                  : v.target.value;
              let disabledOk = false;
              Object.entries(webVerifyFields).forEach(
                (o: [string, string[]]) => {
                  if (!disabledOk && o[1].includes(e.code)) {
                    disabledOk = true;
                    tempValues[o[0]] = 0;
                  }
                },
              );
              setWindowValues({ webSettings: tempValues });
            },
            btnClick: async () => {
              const verifiedValue = await verifyWebData(
                e.code,
                getWebData(e.code),
                {
                  setMsg2,
                  startSendData,
                  closeMsg,
                },
              );
              setWindowValues({
                webSettings: {
                  ...windowValues.webSettings,
                  [e.code]: verifiedValue,
                },
              });
            },
          };
        }),
        buttons: [
          {
            label: t("p.update"),
            onClick: saveWebSetting,
            color: colors.green,
          },
          {
            label: t("p.cancel"),
            onClick: closeMsg,
            color: colors.darkGrey,
          },
        ],
      }
    : {};
};
